'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { toasterApi } from '@terra/ui-design-system';
import { useUpdateApplicationFields } from '../../../hooks/api/useUpdateApplicationFields';

export function useTicketingRetestDelayToggle({
  applicationId,
  currentValue,
  isReadOnly,
}: {
  applicationId: string;
  currentValue: boolean;
  isReadOnly?: boolean;
}) {
  const t = useTranslations('designSystem.applicationGeneral');
  const { mutateAsync: updateApplicationFields, isPending: isUpdating } =
    useUpdateApplicationFields();

  const handleCheckedChange = useCallback(
    async ({ checked }: { checked: boolean }) => {
      if (isReadOnly || checked === currentValue) {
        return;
      }

      try {
        await updateApplicationFields({
          applicationId,
          body: { applyDeploymentDelayToTicketingRetests: checked },
        });
        toasterApi.success({ title: t('saveSuccess') });
      } catch (error: unknown) {
        console.error(
          new Error('Failed to update ticketing retest delay'),
          error,
        );
        toasterApi.error({
          title: t('saveError'),
          description: error instanceof Error ? error.message : undefined,
        });
      }
    },
    [applicationId, currentValue, isReadOnly, t, updateApplicationFields],
  );

  return { isUpdating, handleCheckedChange };
}
